var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-annotating',_vm._g(_vm._b({attrs:{"type":"analysing","intro":"Start creating your Visual Analysis block by adding a "}},'bb-annotating',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }